import { createContext, useContext, useState, useEffect } from 'react';
import { getMe } from '../services/api';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedToken = localStorage.getItem('brolax_admin_token');
    if (savedToken) {
      getMe()
        .then((data) => setAdmin(data))
        .catch((err) => {
          console.error('Auth check failed:', err.message);
          // Only clear token if it's a real authentication error
          if (err.message === 'انتهت الجلسة' || err.message === 'غير مصرح') {
            localStorage.removeItem('brolax_admin_token');
            setAdmin(null);
          }
          // For network errors or server issues, keep the token
          // so the user stays "logged in" and can retry
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = (token, adminData) => {
    localStorage.setItem('brolax_admin_token', token);
    setAdmin(adminData);
  };

  const logout = () => {
    localStorage.setItem('brolax_admin_token', '');
    localStorage.removeItem('brolax_admin_token');
    setAdmin(null);
  };

  if (loading) return <div className="text-center py-20 text-xl text-white">جار التحميل...</div>;

  return (
    <AuthContext.Provider value={{ admin, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);